<template>
  <div class="map">
    <template v-if="error">
      <div class="error">
        {{ error }}
      </div>
    </template>
    <template v-else>
      <div class="map__left">
        <div id="map" style="width: 100%; height: 100%;"></div>
      </div>
      <div class="map__right">
        <div id="panorama" style="width: 100%; height: 100%;"></div>
      </div>
    </template>
  </div>
</template>

<script>
const GoogleMapApiKey = process.env.VUE_APP_GOOGLE_MAP_API_KEY
import GoogleMapsLoader from 'google-maps'
GoogleMapsLoader.KEY = GoogleMapApiKey
GoogleMapsLoader.VERSION = '3.41'
GoogleMapsLoader.LIBRARIES = ['geocoder', 'places']
GoogleMapsLoader.LANGUAGE = 'ja'
GoogleMapsLoader.REGION = 'JP'
import BukkenRepository from '@/repositories/bukkenRepository'
export default {
  created() {},
  mounted() {
    const id = this.$route.params.id
    // 物件情報を取得する
    this.getProperty(id)
  },
  data() {
    return {
      map: null,
      panorama: null,
      lat: null,
      lon: null,
      mapOption: {
        zoom: 18,
        gestureHandling: 'greedy',
        mapTypeControl: false, //マップタイプ コントロール
        fullscreenControl: true, //全画面表示コントロール
        streetViewControl: false, //ストリートビュー コントロール
        zoomControl: true, //ズーム コントロール,
        scrollwheel: false,
        mapId: "c86fa7b5a3f84cd5"
      },
      panoramaOption: {
        zoom: 18,

        mapTypeControl: false, //マップタイプ コントロール
        fullscreenControl: true, //全画面表示コントロール
        streetViewControl: false, //ストリートビュー コントロール
        zoomControl: true, //ズーム コントロール,
        scrollwheel: false,
        streetview: true,
      },
      error: '',
    }
  },
  methods: {
    // 建物情報を取得
    async getProperty(id) {
      await BukkenRepository.getOne(id)
        .then(res => {
          if (res.result) {
            const data = res.data
            if (data.b_regulars.latitude && data.b_regulars.longitude) {
              this.lat = data.b_regulars.latitude
              this.lon = data.b_regulars.longitude
              // GoogleMapの設定
              GoogleMapsLoader.load(this.loadMap)
            } else {
              alert('物件情報に住所が登録されていません。')
              this.error = '物件情報に住所が登録されていない為、マップを表示できません。'
            }
          } else {
            alert('物件情報の取得に失敗しました。')
            this.error = '物件情報の取得に失敗した為、マップを表示できません。'
          }
        })
        .catch(e => {
          console.log(e)
          alert('物件情報の取得に失敗しました。')
          this.error = '物件情報の取得に失敗した為、マップを表示できません。'
        })
    },
    // 住所から緯度経度を取得、マップ表示
    async mapDisplay(geocoderParam) {
      let geocoder = new google.maps.Geocoder()
      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
      console.log(AdvancedMarkerElement)
      geocoder.geocode(geocoderParam, (results, status) => {
        // eslint-disable-next-line no-undef
        if (status === google.maps.GeocoderStatus.OK) {
          this.map.setCenter(results[0].geometry.location)
          this.panorama.setCenter(results[0].geometry.location)
          // 緯度経度の取得
          // results[0].geometry.location.lat();
          // results[0].geometry.location.lng();
          this.marker = new google.maps.marker.AdvancedMarkerElement({
            map: this.map,
            position: results[0].geometry.location,
            draggable: false, // PIN移動を許可
          })

          let panorama = this.panorama.getStreetView()
          panorama.setPosition(results[0].geometry.location)
          panorama.setPov({
            heading: 265,
            zoom: 1,
            pitch: 0,
          })
          panorama.setVisible(true)
          this.marker = new google.maps.Marker({
            map: this.panorama,
            position: results[0].geometry.location,
            draggable: false, // PIN移動を許可
          })
        }
      })
    },
    // googleMap設定
    // eslint-disable-next-line no-unused-vars
    loadMap(google) {
      this.initMap()
      if (this.lat && this.lon) {
        let latlon = { lat: parseFloat(this.lat), lng: parseFloat(this.lon) }
        this.mapDisplay({ location: latlon })
      }
    },
    // マップを初期化する
    initMap() {
      // googleMapを初期化
      this.map = new google.maps.Map(document.getElementById('map'), this.mapOption)
      // googleMapを初期化
      this.panorama = new google.maps.Map(document.getElementById('panorama'), this.panoramaOption)
    },
  },
}
</script>

<style lang="scss" scoped>
.map {
  display: flex;
  height: 100vh;

  &__left {
    width: 40%;
    height: 100%;
    padding: 8px;
    border-right: 2px dashed #999;
  }
  &__right {
    width: 60%;
    padding: 8px;
  }

  .error {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
